import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { NotFound } from "@/components/app/not-found";
import { Toaster } from "@/components/ui/sonner";
import type { AuthSnapshot } from "@/lib/auth";

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthSnapshot;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }) => (
    <div className="p-8 space-y-4">
      <h1 className="text-xl font-display text-destructive">Something went wrong</h1>
      <pre className="text-sm text-muted-foreground">{error.message}</pre>
      <button type="button" className="underline" onClick={reset}>
        Reload
      </button>
    </div>
  ),
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster richColors closeButton position="top-right" />
    </>
  );
}
